import { createAsyncThunk } from '@reduxjs/toolkit';
import { TimetableTripRoute } from 'model/TimetableTripRoute';
import { createApiService } from 'service';

export enum ActionTypes {
    GET_ALL_TIMETABLE_TRIP_ROUTE = 'getTimeTableTripRoute',
    GET_TIMETABLE_USER = 'getTimeTableUser',
}

export const createTimetableTripRouteService = () => {
    const apiService = createApiService();
    return {
        getTimetableTripRoute: (id: number): Promise<TimetableTripRoute[]> => {
            return apiService.get(`timetable/timetabletriproute/${id}`);
        },
        getTimetableUser: (token: string): Promise<string> => {
            return apiService.get(`timetable/timetableuser/${token}`);
        }
    }
}

export const createTimetableTripRouteAction = () => {
    const service = createTimetableTripRouteService();

    const getTimetableTripRoute = createAsyncThunk<TimetableTripRoute[], number>(ActionTypes.GET_ALL_TIMETABLE_TRIP_ROUTE,
        (id, thunkApi) => service.getTimetableTripRoute(id).catch((error) => thunkApi.rejectWithValue(error))
    );

    const getTimetableUser = createAsyncThunk<string, string>(ActionTypes.GET_TIMETABLE_USER,
        (token, thunkApi) => service.getTimetableUser(token).catch((error) => thunkApi.rejectWithValue(error))
    );

    return { getTimetableTripRoute, getTimetableUser };
}
